import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import CacheBuster from 'react-cache-buster'
import 'react-chatbot-kit/build/main.css'
import { createRoot } from 'react-dom/client'
import App from './App'
import Loader from './components/global/Loader'

const version = import.meta.env.VITE_VERSION
const isProduction = import.meta.env.MODE === 'production'

const pathname = window.location.pathname

if (pathname === '/') {
    window.location.assign('/fr/')
}

const queryClient = new QueryClient()

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
    <React.StrictMode>
        <CacheBuster
            currentVersion={version}
            isEnabled={isProduction} //If false, the library is disabled.
            isVerboseMode={false} //If true, the library writes verbose logs to console.
            loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
        >
            <QueryClientProvider client={queryClient}>
                <App />
            </QueryClientProvider>
        </CacheBuster>
    </React.StrictMode>,
)
